// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { BitMaskMessage, BitMaskMessageT } from './bit-mask-message';
import { OneHotMessage, OneHotMessageT } from './one-hot-message';


export enum EncodedMessageContent {
  NONE = 0,
  OneHotMessage = 1,
  BitMaskMessage = 2
}

export function unionToEncodedMessageContent(
  type: EncodedMessageContent,
  accessor: (obj:BitMaskMessage|OneHotMessage) => BitMaskMessage|OneHotMessage|null
): BitMaskMessage|OneHotMessage|null {
  switch(EncodedMessageContent[type]) {
    case 'NONE': return null; 
    case 'OneHotMessage': return accessor(new OneHotMessage())! as OneHotMessage;
    case 'BitMaskMessage': return accessor(new BitMaskMessage())! as BitMaskMessage;
    default: return null;
  }
}

export function unionListToEncodedMessageContent(
  type: EncodedMessageContent, 
  accessor: (index: number, obj:BitMaskMessage|OneHotMessage) => BitMaskMessage|OneHotMessage|null, 
  index: number
): BitMaskMessage|OneHotMessage|null {
  switch(EncodedMessageContent[type]) {
    case 'NONE': return null; 
    case 'OneHotMessage': return accessor(index, new OneHotMessage())! as OneHotMessage;
    case 'BitMaskMessage': return accessor(index, new BitMaskMessage())! as BitMaskMessage;
    default: return null;
  }
}
